import '@kne/react-form-antd-mobile/dist/index.css';
import '@kne/react-city-select-mobile/dist/index.css';
import {preset as fetchPreset} from '@kne/react-fetch';
import axios from 'axios';
import {Toast, Result, Empty, DotLoading} from 'antd-mobile'
import {interceptors} from '@kne/react-form-antd-mobile';
import dayjs from 'dayjs';
import accountToken from './util/accountToken';

interceptors.input.use('picker-single', (value) => {
    return value ? [value] : [];
});

interceptors.output.use('picker-single', (value) => {
    return value ? value[0] : null;
});

interceptors.input.use('date', (value) => {
    return value ? new Date(value) : null;
});

interceptors.output.use('date', (value) => {
    return value ? dayjs(value).format('YYYY-MM-DD') : null;
});

interceptors.input.use('salary', (value) => {
    if (!value || typeof value !== 'string') {
        return value;
    }

    const matcher = value.match(/月薪:([0-9]{1,})元x([0-9]{1,})月/);
    if (matcher && matcher.length > 2) {
        return [matcher[1], matcher[2]]
    }
    return []
});

interceptors.output.use('salary', (value) => {
    if (!Array.isArray(value)||!value[0] ) {
        return "";
    }
    return `月薪:${value[0]}元x${value[1]||12}月`;
});

export const ajax = axios.create({
    validateStatus: function () {
        return true;
    }
});

ajax.interceptors.request.use((config) => {
    config.headers = {
        'X-CNDIDATE-TOKEN': accountToken.token
    };
    if (config.method.toUpperCase() !== 'GET') {
        config.headers['Content-Type'] = 'application/json';
    }
    return config;
});

ajax.interceptors.response.use((response) => {
    if (response.status !== 200 || response.data.code !== 0) {
        Toast.show({
            content: response.data.msg || '请求发生错误',
        });
    }
    if (response.data.code === 401) {
        window.wx.miniProgram.navigateTo({
            url: '/pages/index/index'
        });
    }
    return response;
});


fetchPreset({
    ajax,
    loading: <DotLoading style={{position: 'absolute', left: '50%', transform: 'translateX(-50%)'}}/>,
    error: <Result status="error" title="请求发生错误"/>,
    empty: <Empty/>,
    transformResponse: (response) => {
        const {data} = response;
        response.data = {
            code: data.code === 0 ? 200 : data.code, msg: data.msg, results: data.data
        };
        return response;
    }
});
